// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"600cb72c","732":"c597a506","977":"bdfb08e5"}[chunkId] + ".chunk.js";
};